export const testimonialData = [
	{
		name: "Tom Hart",
		message: "I ordered a bunch of framed prints as gifts, and one for myself. I love them, I want more, wish my whole house was salon-style pictures from PDR.",
		town: "Providence, RI",
		country: "United States",
		stars: 5,
	}, {
		name: "Todd Pearson",
		message: "The PDR print shop is an excellent resource for unusual and unique prints from every era and style.  They are beautifully executed, and arrive quickly.  My highest recommendation!",
		town: "San Francisco, CA",
		country: "United States",
		stars: 5,
	},
	{
		name: "Mark W",
		message: "I got a framed Munch print as a Christmas gift for my brother. The print was beautiful with super clear resolution and the framing was immaculate.",
		town: "Baltimore, MD",
		country: "United States",
		stars: 5,
	},
	{
		name: " Simon",
		message: "Beautiful reproductions, incredible imagination and imaginative curation. Great care taken with packaging and presentation.",
		town: "London",
		country: "United Kingdom",
		stars: 5,
	},
	{
		name: "David Houston",
		message: "Just gorgeous prints - I’ve ordered around four over the years and they’re honestly faultless. Huge recommendation.",
		town: "London",
		country: "United Kingdom",
		stars: 5,
	},
	{
		name: "Thilde Wolf",
		message: "Stunning prints in excellent quality. I could not be happier with the results. I will continue to fill my home with art from PDR’s prints shop.",
		town: "Lund",
		country: "Sweden",
		stars: 5,
	},
	{
		name: "Sohraub",
		message: "Prints arrived relatively quickly and were of very high quality.",
		town: "Toronto",
		country: "Canada",
		stars: 5,
	},
	{
		name: "Rich M",
		message: "Love the quality of the print and the frame.",
		town: "Mt Airy, MD",
		country: "United States",
		stars: 5,
	},
	{
		name: "Schmudde",
		message: "I own several PDR prints and have also given them as gifts. The attention to detail never disappoints! This is true from the curation to the artifact that you receive in the mail. Highly recommended.",
		town: "Turin",
		country: "Italy",
		stars: 5,
	},
	{
		name: "George Webster",
		message: "I’m addicted to these prints. The quality is exceptional and if you’re a fan of the PDR, then these are a no-brainer. I’ve got a small collection now. They also make for excellent, original gifts.",
		town: "London",
		country: "United Kingdom",
		stars: 5,
	},
];